export interface FilterItem {
    key: string;
    value: string;
}
export interface SortOrder {
    label: string;
    order: string;
}

export default class Search {

    static getFilterString(filters: FilterItem[]) {
        let filterString: string = '';
        let sign: string = '';

        filters.filter((filter) => filter.value).forEach((filter, index) => {
            sign = index === 0 ? '?' : '&';
            filterString += `${sign}${filter.key}=${filter.value}`;
        });
        return filterString;
    }

    static getOrderingString(filters: FilterItem[], sortOrder: SortOrder) {
        let sign = filters.length === 0 ? '?' : '&';
        if (!sortOrder.label) return '';
        return `${sign}ordering=${sortOrder.order}${sortOrder.label}`;
    }

    static getQueryString(filters: FilterItem[], sortOrder: SortOrder) {
        return `${this.getFilterString(filters)}${this.getOrderingString(filters, sortOrder)}`;
    }
}